import { render } from "./DeleteTrimModal.vue?vue&type=template&id=50763275"
import script from "./DeleteTrimModal.vue?vue&type=script&lang=js"
export * from "./DeleteTrimModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__